import React, { useEffect, useState } from "react";
import { fetchTransactionSummary } from "../api/transactionApi";


const TransactionSummaryTable = ({ username,filterUser,start, end }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await fetchTransactionSummary(username, filterUser,start, end);
        setData(result);
      } catch (error) {
        console.error("요약 정보 불러오기 실패", error);
      }
    };
    load();
  }, [username, filterUser,start, end]);

  return (
    <table className="summary border text-sm w-full">
      <thead>
        <tr>
          {data.map((d, idx) => (
            <th key={idx} className="p-2 border text-center bg-gray-100">{d.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {data.map((d, idx) => (
            <td key={idx} className="p-2 border text-center">
              {d.amount.toLocaleString()} 원 ({d.count}건)
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};

export default TransactionSummaryTable;